
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1ohxk_93",
  "pad-bottom": "awsui_pad-bottom_15o6u_1ohxk_113",
  "has-background": "awsui_has-background_15o6u_1ohxk_122",
  "highlighted": "awsui_highlighted_15o6u_1ohxk_125",
  "selected": "awsui_selected_15o6u_1ohxk_125",
  "disabled": "awsui_disabled_15o6u_1ohxk_139",
  "next-item-selected": "awsui_next-item-selected_15o6u_1ohxk_147",
  "is-keyboard": "awsui_is-keyboard_15o6u_1ohxk_155",
  "parent": "awsui_parent_15o6u_1ohxk_159",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1ohxk_163",
  "child": "awsui_child_15o6u_1ohxk_175",
  "virtual": "awsui_virtual_15o6u_1ohxk_190",
  "measure-strut": "awsui_measure-strut_15o6u_1ohxk_201",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_1ohxk_210",
  "screenreader-content": "awsui_screenreader-content_15o6u_1ohxk_214",
  "option-content": "awsui_option-content_15o6u_1ohxk_220"
};
  